import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.css'],
    standalone: false
})
export class ListComponent implements OnInit {

  constructor(private http: HttpClient) { }

  public configObj = {
    userName: "",
    mode: "",
    tenantList: [],
  };

  public navigateToDomain(tenant: any) {
    var url = tenant.RedirectURL + '?idpUrl=' + tenant.IDP;
    window.location.href = url;
  }

  private getTenants() {
    let api = "/api/GateWay/GetTenantData/?userId=" + this.configObj.userName;
    this.http.get(api).subscribe((res: any) => {
      this.configObj.tenantList = res;
    }, () => { })
  }

  private init() {
    let cookies = document.cookie.split(";")
    let cookieName = 'i2eUrl=';
    let cookieval = "";
    for (let i: number = 0; i < cookies.length; i += 1) {
      cookieval = cookies[i].replace(/^\s+/g, '');
      if (cookieval.indexOf(cookieName) == 0) {
        this.configObj.userName = cookieval.substring(cookieName.length, cookieval.length);
      }
    }

    //this.configObj.userName = cookies[0].('i2eUrl=');    if (this.configObj.userName == undefined || this.configObj.userName == 'null' || this.configObj.userName == null) {
      this.configObj.mode = 'notLoggedIn';
    }    else {
      this.getTenants()
    }
    console.log(this.configObj.userName);
  }

  ngOnInit(): void {
    this.init();
  }

}
